<script>
import { referral } from "@local/store/referral"
import Default from "./default.svelte"
import NyCardCampaign from "./nyCardCampaign.svelte"
import PaCardCampaign from "./paCardCampaign.svelte"
import TilrayCampaign from "./tilrayCampaign.svelte"
import PapTracker from "./papTracker.svelte"
import JaneTracker from "./janeTracker.svelte"

export let subdomain

let tracker = Default

function updateTracker(subdomain, referral) {
  if (subdomain === "tilray") {
    tracker = TilrayCampaign
    return
  }
  tracker = Default
}

$: updateTracker(subdomain, $referral)
</script>

<svelte:component this="{tracker}" />
